module.exports = __webpack_public_path__ + "img/branch.2f2bc70c.png";